export const Lang = {
  title: 'St. Andrews Links Map',
  infoWindow: {
    btnText: 'Edit this location',
    typeText: 'Location Type: ',
  },
};
